module.exports = {
  isProd : process.env.NODE_ENV == 'production' ? true : false,
  baseUrl : process.env.NODE_ENV == 'production' ? 'https://api.simpleish.io/v1' : 'http://127.0.0.1:8000',
  helpDeskUrl : process.env.NODE_ENV == 'production' ? 'https://simpleish.io/simpleish-helpdesk' : 'http://127.0.0.1:8001',
  paddleVendorId : process.env.NODE_ENV == 'production' ? 141932 : 4925
}